export enum VideoCreationType {
    VENDOR = 1,
    EDUCATIONAL = 2,
    DOMESTIC = 3
}
